import React, { memo, useMemo } from 'react';
import { FaExclamation } from 'react-icons/fa';
import { LiaComment } from 'react-icons/lia';
import { MdOutlineDeleteOutline } from 'react-icons/md';
import { useSelector } from 'react-redux';
import { formatPrice, formatTime } from '../../../utils/formatter';
import Button from '../../shared/buttons/Button';
import Row from '../../shared/table/Row';
import SelectableRow from '../../shared/table/SelectableRow';
import Table from '../../shared/table/Table';

const VisitTasksTable = ({ visitTasks, loading, onVisitTaskClick, onVisitTaskDeleteClick, readOnly }) => {
  const isTabletView = useSelector((state) => state.screen.isTabletView);
  const tableRows = useMemo(
    () =>
      visitTasks.map((visitTask, i) => (
        <SelectableRow key={i} onClick={() => onVisitTaskClick(visitTask)}>
          <Row>
            <div className="flex gap-1 items-center">
              {visitTask.comment && <LiaComment size={20} className="text-contrast1" />}
              {visitTask.isCritical && <FaExclamation size={14} className="text-contrast1" />}
              {visitTask.task.name}
            </div>
          </Row>
          {!isTabletView && <Row children={formatPrice(visitTask.rate)} />}
          <Row children={formatTime(visitTask.hours)} />
          <Row children={formatPrice(visitTask.price)} />
          {!readOnly && (
            <Row
              children={
                <div title="Видалити" className="w-full text-end z-10">
                  <Button
                    onClick={(event) => {
                      event.stopPropagation();
                      onVisitTaskDeleteClick(visitTask);
                    }}
                    variant="secondary2"
                    disabled={loading}
                  >
                    <MdOutlineDeleteOutline size={20} />
                  </Button>
                </div>
              }
            />
          )}
        </SelectableRow>
      )),
    [isTabletView, readOnly, onVisitTaskDeleteClick, loading, visitTasks, onVisitTaskClick],
  );
  return (
    <Table
      columns={isTabletView ? mobileColumns(readOnly) : columns(readOnly)}
      data={tableRows}
      onRowClick={() => ({})}
    />
  );
};

function mobileColumns(readOnly) {
  if (readOnly) {
    return [
      { name: 'Назва', className: 'w-[70%]' },
      { name: 'н/г', className: 'w-[15%]' },
      { name: 'Ціна', className: 'w-[15%]' },
    ];
  } else {
    return [
      { name: 'Назва', className: 'w-[65%]' },
      { name: 'н/г', className: 'w-[15%]' },
      { name: 'Ціна', className: 'w-[15%]' },
      { name: 'Дії', className: 'w-[5%] text-center' },
    ];
  }
}

function columns(readOnly) {
  if (readOnly) {
    return [
      { name: 'Назва', className: 'w-[70%]' },
      { name: 'Ціна н/г', className: 'w-[15%]' },
      { name: 'н/г', className: 'w-[15%]' },
      { name: 'Ціна', className: 'w-[15%]' },
    ];
  } else {
    return [
      { name: 'Назва', className: 'w-[60%]' },
      { name: 'Ціна н/г', className: 'w-[15%]' },
      { name: 'н/г', className: 'w-[10%]' },
      { name: 'Ціна', className: 'w-[10%]' },
      { name: 'Дії', className: 'w-[5%] text-center' },
    ];
  }
}

export default memo(VisitTasksTable);
